import React from 'react';
import audioIcon from '../Images/icons3.png';

interface Props {
  title: string;
  onClick?: (e?: React.MouseEvent) => void;
}

const parseTitle = (title: string): string[] => {
  if (!title) return [];
  const match = title.match(/^(.*?)\s+(\d{2}\/\d{2}\/\d{4})\s+(.+)$/);
  if (match) {
    return [match[1], match[2], match[3]];
  }
  return [title];
};

const HorizontalCardForAud: React.FC<Props> = ({ title, onClick }) => {
  const lines = parseTitle(title);
  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "8px",
        width: "27vw",
        height: "38vw",
        textAlign: "center",
        flex: "0 0 auto",
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
      } as React.CSSProperties}
      onClick={onClick}
    >
      <div>
        <img src={audioIcon} height={60} width={60} />
      </div>
      {lines.length > 0 && (
        <div style={{ marginTop: "4px" }}>
          {lines.map((line, i) => (
            <div key={i} style={{
              fontWeight: "bold",
              color: "#4b2e2e",
              fontSize: "13px",
              lineHeight: "1.3",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              wordBreak: "break-word"
            }}>
              {line}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HorizontalCardForAud;
